module.exports = __webpack_public_path__ + "media/images/hodzzy-mark-c10cbe840b6224277eaeb9aa86b203b2.png";